module.exports = __webpack_public_path__ + "img/ditandai_inbox.d2bbd333.svg";